export default function () {
  let node = document.getElementById('bar');

  if (!node) return;
  let trigger = document.querySelector('[data-bar-trigger]');

  window.addEventListener('scroll', () => {
    if (trigger.getBoundingClientRect().top < 0) {
      node.classList.add('-active');
    } else {
      node.classList.remove('-active');
    }
  });
}